import { createFileRoute } from '@tanstack/react-router';
import { AdminModerationReportView } from '@/components/admin/AdminModerationReportView';
import { AdminShell } from '@/components/admin/AdminShell';
import { platformAdminItemsForRole } from '@/components/admin/admin-sidebar-items';
import { useAuthedSession } from '@/lib/use-session';

export const Route = createFileRoute('/_authed/admin/moderation/$reportId')({
  component: ModerationReportPage,
});

function ModerationReportPage() {
  const { reportId } = Route.useParams();
  const session = useAuthedSession();
  return (
    <AdminShell
      items={platformAdminItemsForRole(session?.platformRole ?? null)}
      active="moderation"
    >
      <AdminModerationReportView reportId={reportId} />
    </AdminShell>
  );
}
